import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebaseClient";

import AdminForm from "../components/AdminForm"

import { Box, CircularProgress, Button, Stack, Typography } from "@mui/material";

export default function Admin() {
    const nav = useNavigate()
    const [checkingAuth, setCheckingAuth] = useState(true);

    useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (!user) {
        nav("/auth");
      } else {
        setCheckingAuth(false);
      }
    });

    return () => unsub();
    }, [nav]);

    async function handleLogout() {
        await signOut(auth);
        nav("/auth");
    }

    if (checkingAuth) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

    return (
    <Box sx={{ px: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h6">Admin</Typography>

        <Button style={{margin:"10px"}} variant="outlined" onClick={handleLogout}>
          Log out
        </Button>
      </Stack>
        
      <AdminForm />
    </Box>
  );
}